export const ROOT_COOKIE_PATH = '/'
